import { render, staticRenderFns } from "./ticketMessagePlaceholder.vue?vue&type=template&id=270fd5d9&"
import script from "./ticketMessagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./ticketMessagePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ticketMessagePlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports